module.exports = __webpack_public_path__ + "img/facebook_sample_image.ab6cf2af.svg";